// The merged desktop app (host + viewer in one). Served statically by Caddy
// from the portal host's /download folder (durable across portal redeploys).
export const APP_DOWNLOAD_URL = "/download/SPIDER-Viewer-Setup.exe";
export const APP_DOWNLOAD_NAME = "SPIDER-Viewer-Setup.exe";
export const APP_PLATFORM_LABEL = "Windows 10/11 · 64-bit";

// Native Linux builds (host + viewer), served from the same durable /download folder.
// AppImage is the universal, no-install default; .deb is for Debian/Ubuntu.
export const LINUX_APPIMAGE_URL = "/download/SPIDER-Viewer-x86_64.AppImage";
export const LINUX_APPIMAGE_NAME = "SPIDER-Viewer-x86_64.AppImage";
export const LINUX_DEB_URL = "/download/SPIDER-Viewer-amd64.deb";
export const LINUX_DEB_NAME = "SPIDER-Viewer-amd64.deb";

export type PlatformKey = "windows" | "macos" | "linux";

// Best-effort OS guess so the download card can highlight the visitor's platform.
export function detectPlatform(): PlatformKey {
  const s = `${navigator.userAgent} ${navigator.platform}`.toLowerCase();
  if (s.includes("mac")) return "macos";
  if (s.includes("linux") || s.includes("x11") || s.includes("android")) return "linux";
  return "windows";
}
